import { ProductType, View } from '@/types';
import { getPrintArea } from './getPrintArea';

export const getDefaultPrintAreaForView = (productType: ProductType, view: View) => {
  if (view.viewMaps) {
    for (const viewMap of view.viewMaps) {
      const printArea = getPrintArea(productType, viewMap.printArea.id);
      if (printArea && !printArea.deprecated) {
        return printArea;
      }
    }
  }
};
